import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'antd'
import css from '../Users.css'
import EditUserModalForm from './EditUserModalForm'

class EditUserModal extends Component {
  static propTypes = {
    dso: PropTypes.bool.isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      practice_id: PropTypes.number.isRequired,
    })).isRequired,
    removeUser: PropTypes.func.isRequired,
    updateAdmin: PropTypes.func.isRequired,
    user: PropTypes.shape({
      email: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      roles: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        resource_id: PropTypes.number.isRequired,
        resource_type: PropTypes.string.isRequired,
      })).isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
    userTypes: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    const {
      user: { email, locations, type },
    } = props
    this.state = {
      confirmPassword: '',
      email,
      password: '',
      userLocations: locations || [],
      userType: type,
    }
  }

  onInputChange = e =>
    this.setState({
      [e.target.name]: e.target.value,
    })

  onAddLocation = (e) => {
    const { userLocations } = this.state
    const val = e.target.value
    const newUserLocations = userLocations.includes(val)
      ? userLocations.filter(loc => loc !== val)
      : [...userLocations, val]
    this.setState({ userLocations: [...newUserLocations] })
  }

  handleSave = (e) => {
    e.preventDefault()
    const { email, password, userLocations, userType } = this.state
    const { close, isTopsAdmin, updateAdmin, user: { id } } = this.props
    const updates = isTopsAdmin && password
      ? { email, password, type: userType }
      : { email, type: userType }
    if (userType === 'location_admin') {
      updates.locations = userLocations
    }
    updateAdmin(id, updates).then(() => close())
  }

  handleRemove = () => {
    const {
      close,
      removeUser,
      user: { id },
    } = this.props
    removeUser(id).then(() => close())
  }

  render() {
    const {
      close,
      dso,
      isTopsAdmin,
      locations,
      userTypes,
    } = this.props
    const {
      confirmPassword,
      email,
      password,
      userLocations,
      userType,
    } = this.state
    const locationAdminInvalid = userType === 'location_admin' && !userLocations.length
    const passwordMismatch = isTopsAdmin && password !== confirmPassword
    const disabled = passwordMismatch || locationAdminInvalid

    const footerButtons = [
      <Button
        key="delete"
        className={css.removeModalButton}
        type="danger"
        onClick={this.handleRemove}
      >
        Delete This User
      </Button>,
      <Button key="cancel" onClick={() => close()}>
        Cancel
      </Button>,
      <Button
        key="submit"
        type="primary"
        onClick={this.handleSave}
        disabled={disabled}
      >
        Save Changes
      </Button>,
    ]

    return (
      <Modal
        title="Update or Delete User"
        visible
        onCancel={() => close()}
        onOk={this.handleSave}
        footer={footerButtons}
      >
        <EditUserModalForm
          confirmPassword={confirmPassword}
          dso={dso}
          email={email}
          isTopsAdmin={isTopsAdmin}
          locations={locations}
          onAddLocation={this.onAddLocation}
          onInputChange={this.onInputChange}
          password={password}
          userLocations={userLocations}
          userType={userType}
          userTypes={userTypes}
        />
      </Modal>
    )
  }
}

export default EditUserModal



// WEBPACK FOOTER //
// ./src/AddPractice/Users/EditUserModal/index.js